import React, { ReactNode, useState } from "react";
import { NavContext } from "./NavContext";


export const NavContextProvider: React.FC<{ children: ReactNode; }> = ({ children }) => {
  const [title, setTitle] = useState("");
  return (
    <NavContext.Provider value={{ title, setTitle: setTitle }}>
      {children}
    </NavContext.Provider>
  );
};
